import unsubscribeActionConstants from '../constants/unsubscribeActionConstants';

const initialState = {
  isUnsubscribed: false,
  isLoading: false,
  error: null,
};

const unsubscribeReducer = (state = initialState, action) => {
  switch (action.type) {
    case unsubscribeActionConstants.UNSUBSCRIBE_REFERRAL_ROUNDUP:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case unsubscribeActionConstants.UNSUBSCRIBE_REFERRAL_ROUNDUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isUnsubscribed: true,
        error: null,
      };
    case unsubscribeActionConstants.UNSUBSCRIBE_REFERRAL_ROUNDUP_ERROR:
      return {
        ...state,
        isLoading: false,
        isUnsubscribed: false,
        error: action.payload || 'Failed to unsubscribe',
      };
    default:
      return state;
  }
};

export default unsubscribeReducer;
